/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SecurityHelper } from 'sarsaparilla';
import { RECAPTCHA_V3, RECAPTCHA_V2, MOBILE_TYPES } from '../constants/recaptcha';

/**
 * Build the obfuscated gate_a payload for issuance POSTs.
 *
 * The `terminal` field tells the backend which verifier to use: V3 for the
 * invisible attempt, V2 for the checkbox retry after a challenge. On a mobile
 * webview the native app injects its own token, so value and terminal come
 * from the SecurityHelper mobile native getters instead.
 */
export function buildGateA({ token, section, isChallengeRequired }) {
    const mobileDeviceType = SecurityHelper.getMobileNativeRecaptchaType();

    if (MOBILE_TYPES.includes(mobileDeviceType)) {
        return {
            value: SecurityHelper.getMobileNativeRecaptchaToken(),
            terminal: mobileDeviceType,
            description: section,
            success: true,
        };
    }

    return {
        value: token,
        terminal: isChallengeRequired ? RECAPTCHA_V2 : RECAPTCHA_V3,
        description: section,
        success: !!token,
    };
}

/**
 * Fetch a token from the fallback hook and build gate_a. A script-load failure
 * resolves the token to null; the backend decides how to treat it.
 */
export async function getGateA(recaptcha, section) {
    let token = null;
    try {
        token = await recaptcha.getToken(section);
    } catch {
        token = null;
    }
    return buildGateA({
        token,
        section,
        isChallengeRequired: recaptcha.isChallengeRequired,
    });
}
